import React from 'react';
const EquipmentSelector = ({ shipmentEquipment, selectedEquipment, allEquipmentsById = {}, onSelect, }) => {
    if (!shipmentEquipment)
        return null;
    return shipmentEquipment.map((eq, index) => {
        let selected = false;
        if (selectedEquipment === eq) {
            selected = true;
        }
        return (React.createElement("button", { "data-testid": `button-9863314a-${index}`, onClick: () => onSelect(selected, allEquipmentsById[eq]), className: "px-2 py-2 mr-2 bg-transparent rounded", style: selected
                ? { border: '1px solid #21b88e', color: '#21b88e' }
                : { border: '1px solid #9e9e9e', color: '#9e9e9e' }, key: eq },
            React.createElement("span", { "data-testid": `span-fe63be10-${index}` }, eq),
            selected && (React.createElement("span", { "data-testid": `span-48915b03-${index}` },
                React.createElement("i", { "data-testid": `i-caf83b36-${index}`, className: "ml-2 fa fa-check-circle-o", style: { color: '#21b88e' } })))));
    });
};
export default EquipmentSelector;
